import _ from 'underscore';

export const formatLocationCriterionToMcaLocation = criterions => (
  _.chain(criterions)
    .filter(criterion => criterion['@odata.type'] !== '#Model.NegativeCampaignCriterion' && criterion.Criterion['@odata.type'] !== '#Model.LocationIntentCriterion')
    .map((item) => {
      const mcaTarget = {
        BingLocationId: item.Criterion.LocationId,
        // City: null,
        Name: item.Criterion.Name,
        Latitude: item.Criterion.GeoPoint ? item.Criterion.GeoPoint.Latitude : item.Criterion.Latitude,
        Longitude: item.Criterion.GeoPoint ? item.Criterion.GeoPoint.Longitude : item.Criterion.Longitude,
        CountryCode: item.Criterion.CountryCode,
        Id: `${item.Id}`,
      };

      // TODP: Miss the parent targets

      if (item.Criterion.Type === 'Radius') {
        // see: private/MultiChannelAds/BusinessMT/Model/Ads/RadiusTarget.cs
        _.extend(mcaTarget, {
          '@odata.type': '#Model.RadiusTarget',
          BingLocationId: 0,
          RadiusLength: item.Criterion.Radius,
          RadiusUnit: item.Criterion.RadiusUnit,
        });
      } else {
        // see: private/MultiChannelAds/BusinessMT/Model/Ads/LocationTarget.cs
        _.extend(mcaTarget, {
          '@odata.type': '#Model.LocationTarget',
          LocationType: item.Criterion.LocationType,
        });
      }

      return mcaTarget;
    })
    .value()
);
